import { combineReducers } from 'redux'

import singleProductSlice from './singleProduct/singleProductSlice'
import articleLink from './articleLink/articleLinkSlice'

export default combineReducers({
	singleProductSlice,
	articleLink
})